<template>
  <sf-alert-base :icon="mdiInformationOutline" type="info" color="blue-grey">
    <slot />
  </sf-alert-base>
</template>

<script setup lang="ts">
import SfAlertBase from '@/components/alerts/SfAlertBase.vue'

import { mdiInformationOutline } from '@mdi/js'
</script>
